import ReactDOM from 'react-dom';
import { StrictMode, FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@kep-ui-kit/ui-theme';
import App from './app/app';
import './styles.css';
import { MarketingInfoProvider } from '@selfserve/react-feature-marketing-info';

const queryClient = new QueryClient();
const UntypedThemeProvider: FC<any> = ThemeProvider;

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <MarketingInfoProvider>
        <UntypedThemeProvider>
          <App />
        </UntypedThemeProvider>
        </MarketingInfoProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
  document.getElementById('app')
);
